
const MOBILE_PUZZLE_KEYBOARD_PREF_KEY = "mobilePuzzleKeyboardPreference";

export function isMobileUserAgent(): boolean {
    const userAgent = navigator.userAgent.toLowerCase();
    return /iphone|ipod|ipad|android|blackberry|windows phone|mobile|mini|tablet/.test(userAgent);
}

export function adjustMobilePuzzleKeyboardPreferences(isOn: boolean): boolean {
    try {
        localStorage.setItem(MOBILE_PUZZLE_KEYBOARD_PREF_KEY, JSON.stringify(isOn));
        return isOn;
    } catch (error) {
        return false; 
    }
}

export function fetchMobilePuzzleKeyboardPreferences(): boolean {
    try {
        const storedPreference = localStorage.getItem(MOBILE_PUZZLE_KEYBOARD_PREF_KEY);
        return storedPreference !== null ? JSON.parse(storedPreference) : true;
    } catch (error) {
        return true;
    }
}